import { theme } from '@zappyrent/hundop';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Media from 'react-media';

import { IUser } from '../../../shared/ts/user';
import useStore from '../../../store';
import Drawer from '../../Drawer';
import UserInfoFields from '../UserInfoFields';
import {
  StyledEyeIcon,
  StyledHeader,
  StyledButton,
  StyledTitle,
  StyledWrapper,
} from './UserInfoPanel.styles';

const UserInfoPanel = (): JSX.Element => {
  const { t } = useTranslation(['a11y', 'translation']);
  const user = useStore(state => state.user);
  const { type } = user as IUser;
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  return (
    <StyledWrapper>
      <StyledHeader>
        <StyledTitle>{t('translation:personalInformation')}</StyledTitle>
        <StyledButton onClick={() => setIsDrawerOpen(true)}>
          {t('a11y:show')}
          <StyledEyeIcon user={type} />
        </StyledButton>
      </StyledHeader>
      <Media
        queries={{
          mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
          desktop: `(min-width: ${theme.breakpoints.l})`,
        }}
      >
        {matches => (
          <>
            {matches.desktop && <UserInfoFields />}
            {matches.mobile && (
              <Drawer
                ariaLabel={t('a11y:close')}
                open={isDrawerOpen}
                title={t('translation:personalInformation')}
                handleClose={() => setIsDrawerOpen(false)}
              >
                <UserInfoFields />
              </Drawer>
            )}
          </>
        )}
      </Media>
    </StyledWrapper>
  );
};

export default UserInfoPanel;
